"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SafetyRule = void 0;
exports.SafetyRule = {
    SexualMinors: "sexual_minors",
    ForgetModeration: "forget_moderation",
    Extremism: "extremism",
    ScamFraud: "scam_fraud",
    Political: "political",
    SelfHarm: "self_harm",
    IllegalDistributionMedical: "illegal_distribution_medical",
    SexualAdults: "sexual_adults",
    Unknown: "unknown",
};
